import { render, staticRenderFns } from "./CarAdditionalDataDetail.vue?vue&type=template&id=02c17bcc&"
import script from "./CarAdditionalDataDetail.vue?vue&type=script&lang=js&"
export * from "./CarAdditionalDataDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports